'use strict';

/* Common Services: Helper */

angular.module('pulse')
  .factory('HelperSvc',
  [
    '$log', '$rootScope', '$window',
    function ($log, $rootScope, $window) {
      return {
        GetListIndex: function(list, item){
          for(var i = 0; i < list.length; i++){
            if(list[i].id === item.id){
              return i;
            }
          }
        },

        checkAppAccess: function() {
          try {
            let pathname = $window.location.pathname;

            if (pathname === '/vfxpulls/') {
                pathname = '/vfx/';
            }

            const applications = $rootScope.storage.applications;
            const isPathMatched = applications.find((app) => app.url === pathname);

            return isPathMatched !== undefined;

          } catch (error) {
              $log.log('Error checking app access', error);
              return false;
          }
        },
      /**
       * Check if the URL contains either '/#!/404' at the end of the URL
       * or '/#!/' followed immediately by '404' as a complete path segment
       * @param {string} url - The URL to check
       * @return {boolean} - True if the URL has the 404 pattern in the correct position
       */
      check404InURL(url) {
        // First check if the URL contains '/#!/'
        const hashIndex = url.indexOf('/#!/');
        
        if (hashIndex !== -1) {
          // Get the part after '/#!/'
          const afterHash = url.substring(hashIndex + 4);
          
          // Check if it's exactly '404' or starts with '404' followed by '/'
          return afterHash === '404' || afterHash === '404/';
        }
        
        return false;
      }

      };
    }
  ]
);
